import React, { useContext } from 'react';
import { Button, Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { URLContext } from '../../contexts/URLContext';
import styled from 'styled-components';

const CustomHeader = styled.div`
  background-color: var(--secondary);
  background-position: bottom center;
  background-size: cover;
  height: 346px;
`;

const CustomLink = styled(Link)`
  text-decoration: none;
`;

const Header = () => {
  const {baseURL, campaignData} = useContext(URLContext);

  return (
    <CustomHeader style={{ backgroundImage: `url(${baseURL}${campaignData.imgBanner})` }}>
      <Grid container>
        <Grid item xs={12} style={{ textAlign:"right", padding: 8 }}>
          <CustomLink to="/regulamento">
            <Button className="white--text bold-text" variant="outlined" style={{border: "transparent"}}>
              Regulamento
            </Button>
          </CustomLink>
          <CustomLink to="/faq">
            <Button className="white--text bold-text" variant="outlined" style={{border: "transparent"}}>
              FAQ
            </Button>
          </CustomLink>
        </Grid>
      </Grid>
    </CustomHeader>
  );
};

export default Header;